import React from 'react';
import styles from './productList.module.scss';
import { KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
// import { KoButton } from 'packages';


const chartConfigs = [
  {
    id: 'totalProduct',
    label: 'Total Product',
    icon: 'ProductOutlined',
    arrow: 'ArrowLineUpFilled',
    description: '+125 today',
    value: `430`
  },
  {
    id: 'published',
    label: 'Published',
    icon: 'PublishedOutlined',
    arrow: 'ArrowLineDownFilled',
    description: '+125 today',
    value: `300`
  },
  {
    id: 'outofStock',
    label: 'Out Of Stock',
    icon: 'OutofStockOutlined',
    arrow: 'ArrowLineDownFilled',
    description: '+0 today',
    value: `10`
  },
  {
    id: 'draft',
    label: 'Draft',
    icon: 'PublishedOutlined',
    arrow: 'ArrowLineUpFilled',
    description: '10 today',
    value: `2`
  }
];


export default function ProductStatus() {

  return (
    <div className={styles.statusWrapper}>
      {chartConfigs.map(({ id, description , icon, arrow, label, value}) => (
        <div key={id} className={styles.card}>
          <div className={styles.header}>
            <KoIcon name={icon} width={25} height={25} color={id==='draft' && '#637381'}/>
            <KoText className={styles.label} text={label} />
          </div>
          <div className={styles.mycontent}>
            <div className={styles.count} >
              <KoTitle level={1} className={styles.value} text={value} />
              <div className={styles.descriptionBox}>
                <KoText className={arrow ==='ArrowLineUpFilled' ?  styles.success : styles.budget} text='10%' />
                <KoIcon name={arrow} width={16} height={16} />
                <KoText className={styles.description} text={description} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}